import { useState, useEffect } from 'react';
import { fetchCounters } from './auth';

// Loads maintained dashboard counters from the API.
// null = loading, false = API failed, object = loaded map.
export function useCounters() {
    const [counters, setCounters] = useState(null);
    useEffect(() => {
        let alive = true;
        const load = () => fetchCounters()
            .then((c) => { if (alive) setCounters(c || {}); })
            .catch(() => { if (alive) setCounters(false); });
        load();
        const onReload = () => load();
        window.addEventListener('fb-reload', onReload);
        return () => { alive = false; window.removeEventListener('fb-reload', onReload); };
    }, []);
    return counters;
}

/** Display a counter field — no live-compute fallback when API is down. */
export function counterVal(counters, key, fmt) {
    if (counters === false) return '—';
    if (counters == null) return '…';
    const v = Number(counters[key]) || 0;
    return fmt ? fmt(v) : v;
}

export default useCounters;